import { getCollectionFields } from '../pluginComponentApi';
import { filterFieldsForDataSearchForm } from '../../fields/FieldTypes';
import {
  FieldTypes,
  MultiSelectOptionFields,
  byFields,
  dateField,
  linkField,
} from 'drapcode-constant';
const { tel, email, large_text, boolean, reference, text, number, custom_uuid } = FieldTypes;
//Used in searchForm
export const getFormComponents = async (collectionName, collections) => {
  const collection = await getCollectionFields(collectionName, collections);
  const fields = collection ? filterFieldsForDataSearchForm(collection.fields) : [];
  let formData = fields.map(async (field, key) => {
    return await renderText(field);
  });
  return (await Promise.all(formData)).join('');
};

const renderText = async (field) => {
  const fieldType = field.type;
  const fieldName = field.fieldName;
  const fieldTitle = field.fieldTitle.en;
  const fieldPlaceholder = field.placeholder.en;
  const displayType = field.refCollection ? field.refCollection.displayType : '';

  if ([text.id, ...linkField, email.id, large_text.id, custom_uuid.id].includes(fieldType)) {
    return `
    <input class="input form-control form-control-sm mb-2 mr-sm-2" type="${fieldType}" name="${fieldName}" value="" placeholder="${fieldTitle}" ${
      fieldType === tel.id ? 'style="margin-bottom: .5rem !important;"' : ''
    }/>
    `;
  } else if ([...dateField, number.id].includes(fieldType)) {
    let startPrefix = 'start';
    let endPrefix = 'end';
    if (fieldType === number.id) {
      startPrefix = 'min';
      endPrefix = 'max';
    }
    const elemType = dateField.includes(fieldType) ? 'date' : fieldType;
    console.log('🚀 ~ Search Form Component ~ renderText ~ elemType:', elemType);
    return `
    <input class="input form-control mb-2 mr-sm-2" type="${elemType}" name="${startPrefix}_${fieldName}"value="" placeholder="${fieldPlaceholder}"/>
    <input class="input form-control mb-2 mr-sm-2" type="${elemType}" name="${endPrefix}_${fieldName}" value="" placeholder="${fieldPlaceholder}"/>
    `;
  } else if (fieldType === boolean.id) {
    return `
    <select class="select form-control mb-2" name="${fieldName}">
      <option value="">- Select ${fieldTitle} -</option>
      <option value="true">Yes</option>
      <option value="false">No</option>
    </select>
    `;
  } else if (
    ([reference.id, ...byFields].includes(fieldType) && displayType === 'dropdown') ||
    MultiSelectOptionFields.includes(fieldType)
  ) {
    return `
    <select class="select form-control mb-2" name="${fieldName}">
      <option value="">- Select ${fieldTitle} -</option>
    </select>
    `;
  }
};
